import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import groupBy from 'lodash/groupBy';
import { AccountHealth, IAccountHealthModalConfig } from 'modals/AccountHealth';
import { selectIsLoadingAPIRequest } from 'store/ApiClient/selectors';
import { IStore } from 'store/types';
import { getUserExpiredPayoutsRequest, User } from 'store/User';

export const EXPIRED_PAYMENTS_MODAL_CONFIG: IAccountHealthModalConfig = {
  modalTitle: 'Expired Payments',
  modalSubtitle: 'Instant payments that can’t be delivered will expire after 30 days.',
  helpListTitle: 'To resolve this, you can:',
  helpListItems: ['Ask your manager to resubmit the payment.', 'Request that your manager convert it to a payroll or cash payment.'],
};

interface ExpiredPaymentsProps {
  isActive: boolean;
  onClose: () => void;
  siteId?: string;
}

const ExpiredPayments = ({ isActive, onClose, siteId }: ExpiredPaymentsProps) => {
  const dispatch = useDispatch();
  const expiredPayouts = useSelector((state: IStore) => state.user?.expiredPayouts?.data || []);
  const isLoading = useSelector((state: IStore) => selectIsLoadingAPIRequest(state, User.GET_USER_EXPIRED_PAYOUTS_REQUEST));
  const groupedPayouts = useMemo(() => groupBy(expiredPayouts, (payout) => payout.site.id), [expiredPayouts]);

  useEffect(() => {
    dispatch(getUserExpiredPayoutsRequest(siteId));
  }, [dispatch, siteId]);

  return <AccountHealth isActive={isActive} onClose={onClose} dataCy="expired-payments" config={EXPIRED_PAYMENTS_MODAL_CONFIG} payouts={groupedPayouts} isLoading={isLoading} />;
};

export default ExpiredPayments;
